<form [formGroup]="formGroup || dummyForm">
    <upp-scrollable [content]="layout === 'fill' ? 'fill' : 'auto'">
        <ng-content></ng-content>
    </upp-scrollable>
</form>
